import { render, staticRenderFns } from "./SameNameOwnersSelectPopup.vue?vue&type=template&id=94255250&scoped=true&"
import script from "./SameNameOwnersSelectPopup.vue?vue&type=script&lang=js&"
export * from "./SameNameOwnersSelectPopup.vue?vue&type=script&lang=js&"
import style0 from "./SameNameOwnersSelectPopup.vue?vue&type=style&index=0&id=94255250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94255250",
  null
  
)

export default component.exports